var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Image",
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m62 1h-24c-.553 0-1 .448-1 1v32c0 .552.447 1 1 1h24c.553 0 1-.448 1-1v-32c0-.552-.447-1-1-1zm-1 32h-22v-30h22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60 38h-26c-1.654 0-3 1.346-3 3v19c0 1.654 1.346 3 3 3h26c1.654 0 3-1.346 3-3v-19c0-1.654-1.346-3-3-3zm1 22c0 .551-.448 1-1 1h-26c-.552 0-1-.449-1-1v-19c0-.551.448-1 1-1h26c.552 0 1 .449 1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m57 56h-2c0-.552-.447-1-1-1s-1 .448-1 1h-16c-1.324 0-1.323 2 0 2h16c0 .552.447 1 1 1s1-.448 1-1h2c1.324 0 1.323-2 0-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33 31v-24c0-1.654-1.346-3-3-3h-26c-1.654 0-3 1.346-3 3v24c0 1.654 1.346 3 3 3h26c1.654 0 3-1.346 3-3zm-2 0c0 .551-.448 1-1 1h-26c-.552 0-1-.449-1-1v-24c0-.551.448-1 1-1h26c.552 0 1 .449 1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21 17c2.206 0 4-1.794 4-4s-1.794-4-4-4-4 1.794-4 4 1.794 4 4 4zm0-6c1.103 0 2 .897 2 2s-.897 2-2 2-2-.897-2-2 .897-2 2-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.707 20.293c-.391-.391-1.023-.391-1.414 0l-3.293 3.293-6.293-6.293c-.391-.391-1.023-.391-1.414 0l-7 7c-.936.936.479 2.349 1.414 1.414l6.293-6.293 6.293 6.293c.391.391 1.023.391 1.414 0l3.293-3.293 3.293 3.293c.922.922 2.362-.467 1.414-1.414z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43 8h10c1.324 0 1.323-2 0-2h-10c-1.324 0-1.323 2 0 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43 17h14c1.324 0 1.323-2 0-2h-14c-1.324 0-1.323 2 0 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43 26h14c1.324 0 1.323-2 0-2h-14c-1.324 0-1.323 2 0 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43 30h5c1.324 0 1.323-2 0-2h-5c-1.324 0-1.323 2 0 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43 13h2c1.324 0 1.323-2 0-2h-2c-1.324 0-1.323 2 0 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m50 13h7c1.324 0 1.323-2 0-2h-7c-1.324 0-1.323 2 0 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43 22h7c1.324 0 1.323-2 0-2h-7c-1.324 0-1.323 2 0 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m57 20h-2c-1.324 0-1.323 2 0 2h2c1.324 0 1.323-2 0-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15 37c-7.72 0-14 4.935-14 11 0 2.469 1.062 4.874 3 6.814v7.186c0 .896 1.083 1.331 1.707.707l4.399-4.399c1.544.46 3.188.692 4.894.692 7.72 0 14-4.935 14-11s-6.28-11-14-11zm0 20c-1.709 0-3.339-.261-4.847-.776-.359-.124-.761-.032-1.03.239l-3.123 3.123v-5.196c0-.278-.115-.543-.318-.732-1.755-1.632-2.682-3.589-2.682-5.658 0-4.962 5.383-9 12-9s12 4.038 12 9-5.383 9-12 9z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 48,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 48,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 48,
    r: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "m45.262 53.714 6.647-3.83c1.448-.833 1.448-2.93 0-3.764l-6.646-3.828c-1.444-.836-3.263.213-3.263 1.881v7.658c0 1.69 1.835 2.702 3.262 1.883zm-1.262-9.541c0-.129.146-.217.264-.148l6.647 3.829c.114.066.114.231 0 .297l-6.646 3.829c-.118.066-.265-.015-.265-.148z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg4);
export default __webpack_public_path__ + "static/media/4.d87ce2d31b1ef835189876e4609fd481.svg";
export { ForwardRef as ReactComponent };